import React from 'react';
import './style.css';

import keygif from './images/key_800.gif';
import logocbr from './images/logocbr.png';
import logofincult from './images/logofincult.png';

const Gratu = ({onBegin}) => {
  return (

    <div className="section-info section-finish">
      <div className="content-rebus w-container">
        <div className="head-rebus">
          <p>Ура! Мы нашли <span className="sel">ключ</span>!</p>
          <p>И теперь я смогу вернуться в мир финансов.</p>
          <p>Если захочешь узнать что-то новое о моей стране заходи на сайт <a href="http://fincult.info" target="blank"><span className="sel">"Финансовая&nbsp;культура" http://fincult.info. </span></a></p>
        </div>
        <div className="head-itog">До скорой встречи!</div>
        <div className="div-block-2 w-clearfix">
          <img src={keygif} loading="lazy" alt="" className="image-13"/>
          <div className="logo-box">
            <a href="http://cbr.ru" target="blank">
            <img src={logocbr} loading="lazy" alt="Банк России" className="image-11"/></a>
            <a href="http://fincult.info" target="blank">
            <img src={logofincult} loading="lazy" alt="Финансовая культура" className="image-12"/></a>
          </div>
        </div>
      </div>
    </div>

  );

};

export default Gratu;
